<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>
  <p>{{content}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{cancelLabel}}</button>
  <button mat-raised-button [mat-dialog-close]="true">{{confirmLabel}}</button>
</mat-dialog-actions>
